export const Lock = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#clip0_3804_7488)">
        <path
          d="M23.9999 10.6668H22.6666V8.00016C22.6666 4.32016 19.6799 1.3335 15.9999 1.3335C12.3199 1.3335 9.33325 4.32016 9.33325 8.00016V10.6668H7.99992C6.53325 10.6668 5.33325 11.8668 5.33325 13.3335V26.6668C5.33325 28.1335 6.53325 29.3335 7.99992 29.3335H23.9999C25.4666 29.3335 26.6666 28.1335 26.6666 26.6668V13.3335C26.6666 11.8668 25.4666 10.6668 23.9999 10.6668ZM15.9999 22.6668C17.4666 22.6668 18.6666 21.4668 18.6666 20.0002C18.6666 18.5335 17.4666 17.3335 15.9999 17.3335C14.5333 17.3335 13.3333 18.5335 13.3333 20.0002C13.3333 21.4668 14.5333 22.6668 15.9999 22.6668Z"
          fill="white"
        />
        <path
          d="M23.9999 10.6668H22.6666V8.00016C22.6666 4.32016 19.6799 1.3335 15.9999 1.3335C12.3199 1.3335 9.33325 4.32016 9.33325 8.00016V10.6668H7.99992C6.53325 10.6668 5.33325 11.8668 5.33325 13.3335V26.6668C5.33325 28.1335 6.53325 29.3335 7.99992 29.3335H23.9999C25.4666 29.3335 26.6666 28.1335 26.6666 26.6668V13.3335C26.6666 11.8668 25.4666 10.6668 23.9999 10.6668ZM11.9999 8.00016C11.9999 5.78683 13.7866 4.00016 15.9999 4.00016C18.2133 4.00016 19.9999 5.78683 19.9999 8.00016V10.6668H11.9999V8.00016ZM23.9999 26.6668H7.99992V13.3335H23.9999V26.6668ZM15.9999 22.6668C17.4666 22.6668 18.6666 21.4668 18.6666 20.0002C18.6666 18.5335 17.4666 17.3335 15.9999 17.3335C14.5333 17.3335 13.3333 18.5335 13.3333 20.0002C13.3333 21.4668 14.5333 22.6668 15.9999 22.6668Z"
          fill="#CA3E00"
        />
      </g>
      <defs>
        <clipPath id="clip0_3804_7488">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CheckCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M15.9998 2.6665C8.63984 2.6665 2.6665 8.63984 2.6665 15.9998C2.6665 23.3598 8.63984 29.3332 15.9998 29.3332C23.3598 29.3332 29.3332 23.3598 29.3332 15.9998C29.3332 8.63984 23.3598 2.6665 15.9998 2.6665Z"
        fill="white"
      />
      <path
        d="M15.9998 2.6665C8.63984 2.6665 2.6665 8.63984 2.6665 15.9998C2.6665 23.3598 8.63984 29.3332 15.9998 29.3332C23.3598 29.3332 29.3332 23.3598 29.3332 15.9998C29.3332 8.63984 23.3598 2.6665 15.9998 2.6665ZM15.9998 26.6665C10.1198 26.6665 5.33317 21.8798 5.33317 15.9998C5.33317 10.1198 10.1198 5.33317 15.9998 5.33317C21.8798 5.33317 26.6665 10.1198 26.6665 15.9998C26.6665 21.8798 21.8798 26.6665 15.9998 26.6665ZM22.1198 10.1065L13.3332 18.8932L9.87984 15.4532L7.99984 17.3332L13.3332 22.6665L23.9998 11.9998L22.1198 10.1065Z"
        fill="#1E8240"
      />
    </svg>
  );
};

export const LockedIcon = () => {
  return (
    <div className="relative">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clipPath="url(#clip0_3804_7472)">
          <circle cx="40" cy="40" r="39" stroke="#999999" strokeWidth="2" />
          <path
            d="M59.06 53H16.94C15.87 53 15 52.13 15 51.06V22.94C15 21.87 15.87 21 16.94 21H59.06C60.13 21 61 21.87 61 22.94V51.06C61 52.13 60.13 53 59.06 53Z"
            fill="white"
          />
          <path
            d="M59.06 54H16.94C15.32 54 14 52.68 14 51.06V22.94C14 21.32 15.32 20 16.94 20H59.06C60.68 20 62 21.32 62 22.94V51.06C62 52.68 60.68 54 59.06 54ZM16.94 22C16.42 22 16 22.42 16 22.94V51.06C16 51.58 16.42 52 16.94 52H59.06C59.58 52 60 51.58 60 51.06V22.94C60 22.42 59.58 22 59.06 22H16.94Z"
            fill="#999999"
          />
          <path d="M15 27H61V33H15V27Z" fill="#FAFAFA" />
          <path
            d="M61 34H15C14.45 34 14 33.55 14 33V27C14 26.45 14.45 26 15 26H61C61.55 26 62 26.45 62 27V33C62 33.55 61.55 34 61 34ZM16 32H60V28H16V32Z"
            fill="#999999"
          />
          <path
            d="M30 47H22C21.45 47 21 46.55 21 46V42C21 41.45 21.45 41 22 41H30C30.55 41 31 41.45 31 42V46C31 46.55 30.55 47 30 47Z"
            fill="#999999"
          />
          <path
            d="M30 48H22C20.9 48 20 47.1 20 46V42C20 40.9 20.9 40 22 40H30C31.1 40 32 40.9 32 42V46C32 47.1 31.1 48 30 48ZM22 42V46H30V42H22Z"
            fill="#999999"
          />
        </g>
        <defs>
          <clipPath id="clip0_3804_7472">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span className="absolute left-10 top-8">
        <Lock />
      </span>
    </div>
  );
};

export const UnLockedIcon = () => {
  return (
    <div className="relative">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <g clipPath="url(#clip0_3765_18581)">
          <circle cx="40" cy="40" r="39" stroke="#1E8240" strokeWidth="2" />
          <path
            d="M58.06 53H15.94C14.87 53 14 52.13 14 51.06V22.94C14 21.87 14.87 21 15.94 21H58.06C59.13 21 60 21.87 60 22.94V51.06C60 52.13 59.13 53 58.06 53Z"
            fill="white"
          />
          <path
            d="M58.06 54H15.94C14.32 54 13 52.68 13 51.06V22.94C13 21.32 14.32 20 15.94 20H58.06C59.68 20 61 21.32 61 22.94V51.06C61 52.68 59.68 54 58.06 54ZM15.94 22C15.42 22 15 22.42 15 22.94V51.06C15 51.58 15.42 52 15.94 52H58.06C58.58 52 59 51.58 59 51.06V22.94C59 22.42 58.58 22 58.06 22H15.94Z"
            fill="#999999"
          />
          <path d="M14 27H60V33H14V27Z" fill="#FAFAFA" />
          <path
            d="M60 34H14C13.45 34 13 33.55 13 33V27C13 26.45 13.45 26 14 26H60C60.55 26 61 26.45 61 27V33C61 33.55 60.55 34 60 34ZM15 32H59V28H15V32Z"
            fill="#999999"
          />
          <path
            d="M29 47H21C20.45 47 20 46.55 20 46V42C20 41.45 20.45 41 21 41H29C29.55 41 30 41.45 30 42V46C30 46.55 29.55 47 29 47Z"
            fill="#999999"
          />
          <path
            d="M29 48H21C19.9 48 19 47.1 19 46V42C19 40.9 19.9 40 21 40H29C30.1 40 31 40.9 31 42V46C31 47.1 30.1 48 29 48ZM21 42V46H29V42H21Z"
            fill="#999999"
          />
        </g>
        <defs>
          <clipPath id="clip0_3765_18581">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span className="absolute left-10 top-8">
        <CheckCircle />
      </span>
    </div>
  );
};
